<template>
  <div class="fanvillage bg-primary">

  <div class="bg-secondary"
    v-if="cookieLogin">
    <b-container class="d-flex align-items-center justify-content-between">
      <span class="font-weight-bold py-1">Welcome, {{cookieLogin}}</span>
      <b-btn href="sso/logout.php" variant="link" class="py-1 px-0" size="sm">
        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
        Logout
      </b-btn>
    </b-container>
  </div>

    <section class="text-white">
      <b-container class="text-center position-relative"
        :class="{'pb-5' : programmeExpired}">
        <b-row>
          <b-col md="10" class="fanvillage__intro mx-auto pt-5">
            <b-img class="fanvillage__logo my-4 my-md-5" src="/img/fan-village/logo.svg" fluid />
            <h1 class="font-weight-bold font-italic text-secondary mb-4 line-height-1 fanvillage__sec-title"
              v-i18n:it="'<span class=\'font-outline\'>Welcome to</span><br />AS Roma Fan Zone'"
              v-i18n:en="'<span class=\'font-outline\'>Welcome to the</span><br />AS Roma Fan Zone'"></h1>
            <p class="font-italic font-weight-bold lead intro-lead mb-4" 
              :class="{'mb-0' : programmeExpired}"
              v-i18n:it="'Benvenuto nella AS Roma Fan Zone, dove il pre-partita si trasforma in un’esperienza unica da vivere! Scopri i giochi e gli ospiti del nostro village e metti alla prova la tua conoscenza della Roma provando a vincere uno dei tanti premi in palio'" 
              v-i18n:en="'Welcome to the AS Roma Fan Zone, where the pre-match experience is transformed into something unforgettable! Hear from  special guests and entertain yourself in a variety of games as you walk around the village – before testing your knowledge of Roma to win one of the many great prizes up for grabs!'"></p>          
            <!--div class="d-flex flex-column d-md-inline-flex">
              <b-link  v-b-toggle.signupModal class="btn btn-secondary btn-lg btn-block text-uppercase">
                <span
                  v-i18n:it="'Registrati ora'"
                  v-i18n:en="'Sign up now!'"></span>
              </b-link>
            </div-->
          </b-col>
        </b-row>
        <div class="position-absolute w-100 px-3 pt-2 pt-lg-3 text-left text-lg-right" style="top:0;left:0;">
          <ul class="list-unstyled d-inline-flex border border-asr-black bg-asr-black rounded-pill">
            <li role="button" class="px-2 py-1 d-flex align-items-center rounded-pill"
              @click="setLanguage('it', 'Italiano')"
              :class="{'bg-primary' : $root.lang.id == 'it'}"><b-img alt="Italiano" class="rouned" src="https://flagcdn.com/it.svg" width="20" /></li>
            <li role="button" class="px-2 py-1 d-flex align-items-center rounded-pill"
              @click="setLanguage('en', 'English')"
              :class="{'bg-primary' : $root.lang.id == 'en'}"><b-img alt="English" class="rouned" src="https://flagcdn.com/gb.svg" width="20" /></li>
          </ul>
        </div>
      </b-container>
    </section>
    
    <div class="sticky-top d-flex justify-content-center py-4"
      v-if="!programmeExpired"
      :class="{invisible: programmeVisible}">
      <div class="rounded-pill bg-secondary px-4 py-2 sticky-pill font-weight-bold font-italic text-primary shadow text-center line-height-1" role="button"
        v-scroll-to="'#programme'">
        <div class="mb-1">
          <span v-i18n:en="'NEXT APPOINTMENT:'" v-i18n:it="'PROSSIMO APPUNTAMENTO:'"></span> {{nextEvent.dateandtime | moment("DD/MM")}}</div>
        <div class="small">
          <span v-i18n:en="'See the programme'" v-i18n:it="'Vedi programma'"></span>
          {{nextEvent.match}}
        </div>
      </div>
    </div>
    
    <b-container class="text-center pb-5">
      <div class="d-flex flex-column d-md-inline-flex">
        <b-link target="_blank" class="btn btn-outline-secondary btn-block"
          :href="$root.lang.id == 'it' ? 'https://www.asroma.com/it/biglietti/' : 'https://www.asroma.com/en/tickets/'">
          <span
            v-if="!programmeExpired">
            <span
              v-i18n:it="'Acquista i biglietti per '"
              v-i18n:en="'Buy tickets for '"></span>
            {{nextEvent.match}}
          </span>
          <span
            v-i18n:it="'Acquista biglietti'"
            v-i18n:en="'Buy tickets'"
            v-else></span>
        </b-link>
      </div>
    </b-container>
    
    <section class="bg-asr-black text-white overflow-hidden">
      <b-container class="pt-5 text-center">
        <b-row>
          <b-col cols="12" class="mx-auto">
            <h1 class="font-weight-bold font-italic text-secondary mb-4 line-height-1 fanvillage__sec-title"
              v-i18n:it="'<span class=\'font-outline\'>Fan</span><br /><span class=\'text-uppercase\'>Engagement</span>'"
              v-i18n:en="'<span class=\'font-outline\'>Fan</span><br /><span class=\'text-uppercase\'>Engagement</span>'"></h1>
            <b-row>
              <b-col md="8" class="mx-auto">
                <p class="mb-4 font-italic" 
                  v-i18n:it="'Nel villaggio giallorosso l’attesa della gara diventa un’esperienza unica con tanti giochi e l’immancabile Romolo'" 
                  v-i18n:en="'In the Giallorosso village, the build-up to the match becomes a unique experience of its own, with lots of games to play and – of course – Romolo always there to meet!'"></p>
              </b-col>
            </b-row>
            <div class="position-relative px-md-3">
              <swiper class="swiper mb-4 mx-n3 mx-md-0 px-3 px-md-0 position-relative text-asr-black" :options="swiperOptions">
                <swiper-slide class="h-auto d-flex flex-column mb-4"
                  v-for="item in filter(stand)">
                  <div class="mb-3 d-flex flex-column flex-grow-1 bg-secondary rounded position-relative">
                    <b-img fluid class="mb-1 rounded-lg product-img"
                      :src="imgTrans(item.img)" />
                      <h2 class="font-weight-bold h4 font-italic mt-n3 text-secondary position-relative mb-4">
                        <span class="bg-primary rounded-pill px-3 d-inline-block shadow"
                          v-i18n.dictionary="item.name"></span>
                      </h2>
                      <p class="font-italic px-4"
                        v-i18n.dictionary="item.description"></p>
                      <div class="coming-soon position-absolute rounded d-flex align-items-center justify-content-center w-100 h-100 text-secondary font-weight-bold font-italic h4 m-0"
                        v-if="item.comingsoon">COMING SOON</div>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination swiper1-pagination" slot="pagination"></div>
              </swiper>
              <div class="swiper-button-prev swiper1-button-prev"><font-awesome-icon icon="chevron-left" class="text-secondary" size="2x"></font-awesome-icon></div>
              <div class="swiper-button-next swiper1-button-next"><font-awesome-icon icon="chevron-right" class="text-secondary" size="2x"></font-awesome-icon></div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mx-auto">
            <p class="font-italic"
              v-i18n:it="'<strong>Registrati qui per accedere più velocemente a tutte le attività del village</strong> e rimanere sempre informato sui prossimi eventi e su tutte le news riguardanti l’AS Roma'" v-i18n:en="'<strong> Register here to access all the activities in the village faster - </strong> and stay informed about all the upcoming events and news regarding AS Roma'"></p>
          </b-col>
        </b-row>
        <div class="pb-5"
          v-if="!cookieLogin">
          <div class="d-flex flex-column d-md-inline-flex">
            <b-link  v-b-toggle.signupModal class="btn btn-primary btn-lg btn-block text-uppercase">
              <span
                v-i18n:it="'Registrati ora'"
                v-i18n:en="'Sign up now!'"></span>
            </b-link>
            <!--b-link href="https://www.asroma.com/it/tickets/buy" target="_blank" class="btn btn-outline-secondary btn-block mt-3">
              <span
                v-i18n:it="'Acquista i biglietti per '"
                v-i18n:en="'Buy tickets for'"></span>
                {{nextEvent.match}}
            </b-link-->
          </div>
        </div>
      </b-container>
    </section>
    <section class="overflow-hidden bg-primary" style="background-image:url(/img/fan-village/bg-text.svg);background-size:150px;background-attachment:fixed;">
      <b-container class="py-5 text-center">
        <b-row>
          <b-col cols="12" class="mx-auto">
            <h1 class="font-weight-bold font-italic text-secondary mb-4 line-height-1 fanvillage__sec-title"
              v-i18n:it="'<span class=\'font-outline\'>Area</span><br /><span class=\'text-uppercase\'>Palco</span>'"
              v-i18n:en="'<span class=\'font-outline\'>Stage</span><br /><span class=\'text-uppercase\'>Area</span>'"></h1>
            <div class="position-relative px-md-3">
              <swiper class="swiper mb-4 mx-n3 mx-md-0 px-3 px-md-0 position-relative" :options="swiper2Options">
                <swiper-slide class="h-auto d-flex flex-column mb-4"
                  v-for="item in filter(palco)">
                  <div class="mb-3 d-flex flex-column flex-grow-1 bg-white rounded position-relative">
                    <b-img fluid class="mb-1 rounded-lg product-img"
                      :src="imgTrans(item.img)" />
                      <h2 class="font-weight-bold h4 font-italic mt-n3 text-primary position-relative mb-4">
                        <span class="bg-secondary rounded-pill px-3 d-inline-block shadow"
                          v-i18n.dictionary="item.name"></span>
                      </h2>
                      <p class="font-italic px-4"
                        v-i18n.dictionary="item.description"></p>
                      <div class="coming-soon position-absolute rounded d-flex align-items-center justify-content-center w-100 h-100 text-secondary font-weight-bold font-italic h4 m-0"
                        v-if="item.comingsoon">COMING SOON</div>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination swiper2-pagination" slot="pagination"></div>
              </swiper>
              <div class="swiper-button-prev swiper2-button-prev"><font-awesome-icon icon="chevron-left" class="text-secondary" size="2x"></font-awesome-icon></div>
              <div class="swiper-button-next swiper2-button-next"><font-awesome-icon icon="chevron-right" class="text-secondary" size="2x"></font-awesome-icon></div>
            </div>
          </b-col>
        </b-row>
        <b-row class="text-white">
          <b-col md="6" class="mx-auto">
            <p class="font-italic"
              v-i18n:it="'<strong>Registrati qui per accedere più velocemente a tutte le attività del village</strong> e rimanere sempre informato sui prossimi eventi e su tutte le news riguardanti l’AS Roma'" v-i18n:en="'<strong> Register here to access all the activities in the village faster - </strong> and stay informed about all the upcoming events and news regarding AS Roma'"></p>
          </b-col>
        </b-row>
        <div class="d-flex flex-column d-md-inline-flex">
          <b-link v-b-toggle.signupModal class="btn btn-secondary btn-lg btn-block text-uppercase"
            v-if="!cookieLogin">
            <span
              v-i18n:it="'Registrati ora'"
              v-i18n:en="'Sign up now!'"></span>
          </b-link>
        </div>
      </b-container>
    </section>
    <!-- section class="bg-asr-black text-white overflow-hidden">
      <b-container class="pt-5 text-center">
        <b-row>
          <b-col cols="12" class="mx-auto">
            <h1 class="font-weight-bold font-italic text-secondary mb-4 line-height-1 fanvillage__sec-title"
              v-i18n:it="'<span class=\'text-uppercase\'>SOSTENIBILITÁ</span>'"
              v-i18n:en="'<span class=\'text-uppercase\'>SUSTAINABILITY</span>'"></h1>
            <p class="mb-4 font-italic" 
              v-i18n:it="'Lorem ipsum dolor amet mustache knausgaard +1, blue bottle waistcoat tbh semiotics artisan synth stumptown gastropub cornhole celiac swag.'" 
              v-i18n:en="'Lorem ipsum dolor amet mustache knausgaard +1, blue bottle waistcoat tbh semiotics artisan synth stumptown gastropub cornhole celiac swag.'"></p>
            <div class="mb-3 d-flex justify-content-center">
              <div class="mb-3 rounded-pill border border-secondary d-flex text-uppercase font-weight-bold text-secondary">
                <div class="px-3 py-1 rounded-pill" role="button"
                  :class="{'bg-secondary text-dark' : currentSustainability == 'community'}"
                  @click="currentSustainability = 'community'">COMMUNITY</div>
                <div class="px-3 py-1 rounded-pill" role="button"
                  :class="{'bg-secondary text-dark' : currentSustainability == 'youth'}"
                  @click="currentSustainability = 'youth'">YOUTH</div>
                <div class="px-3 py-1 rounded-pill" role="button"
                  :class="{'bg-secondary text-dark' : currentSustainability == 'environment'}"
                  @click="currentSustainability = 'environment'">ENVIRONMENT</div>
              </div>
            </div>
            <div class="position-relative px-md-3">
              <swiper class="swiper mb-4 mx-n3 mx-md-0 px-3 px-md-0 position-relative text-asr-black" :options="swiper3Options">
                <swiper-slide class="h-auto d-flex flex-column mb-4"
                  v-for="item in filter(sustainabilityData)">
                  <div class="mb-3 d-flex flex-column flex-grow-1 bg-secondary rounded">
                    <b-img fluid class="mb-1 rounded-lg product-img"
                      :src="imgTrans(item.img)" />
                      <h2 class="font-weight-bold h4 font-italic mt-n3 text-secondary position-relative mb-4">
                        <span class="bg-primary rounded-pill px-3 d-inline-block shadow"
                          v-i18n.dictionary="item.name"></span>
                      </h2>
                      <p class="font-italic px-4"
                        v-i18n.dictionary="item.description"></p>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination swiper3-pagination" slot="pagination"></div>
              </swiper>
              <div class="swiper-button-prev swiper3-button-prev"><font-awesome-icon icon="chevron-left" class="text-primary" size="2x"></font-awesome-icon></div>
              <div class="swiper-button-next swiper3-button-next"><font-awesome-icon icon="chevron-right" class="text-primary" size="2x"></font-awesome-icon></div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mx-auto">
            <p class="font-italic"
              v-i18n:it="'<strong>Registrati qui per accedere più velocemente a tutte le attività del village</strong> e rimanere sempre informato sui prossimi eventi e su tutte le news riguardanti l’AS Roma'" v-i18n:en="'<strong> Register here to access all the activities in the village faster - </strong> and stay informed about all the upcoming events and news regarding AS Roma'"></p>
          </b-col>
        </b-row>
        <div class="pb-5"
          v-if="!cookieLogin">
          <div class="d-flex flex-column d-md-inline-flex">
            <b-link  v-b-toggle.signupModal class="btn btn-primary btn-lg btn-block text-uppercase">
              <span
                v-i18n:it="'Registrati ora'"
                v-i18n:en="'Sign up now!'"></span>
            </b-link>
          </div>
        </div>
      </b-container>
    </section -->
    
    <section class="d-flex flex-column position-relative bg-asr-black" id="fv-inhabitants">
      <transition name="fade">
        <div class="inhab-image inhab-image--romolo position-absolute w-100 h-100"
          v-if="currentInhabitant == 'romolo'" key="inh-romolo"></div>
        <div class="inhab-image inhab-image--band position-absolute w-100 h-100"
          v-else key="inh-band"></div>
      </transition>
      <div class="inhab-mask bg-asr-black d-none d-lg-block"></div>
      <b-container class="py-5 text-center flex-grow-1 d-flex flex-column position-relative">
        <b-row class="my-auto">
          <b-col lg="6" class="ml-auto">
            <h1 class="font-weight-bold font-italic mb-4 line-height-1 fanvillage__sec-title text-secondary"
              v-i18n:it="'<span class=\'font-outline\'>Incontra</span><br /><span class=\'text-uppercase\'>Romolo</span>'"
              v-i18n:en="'<span class=\'font-outline\'>Meet</span><br /><span class=\'text-uppercase\'>Romolo</span>'"></h1>
            <b-img src="/img/fan-village/bg-romolo-6.webp" fluid class="d-lg-none rounded mb-4" />
            <p class="h4 mb-3 mb-lg-4 font-italic font-weight-bold text-secondary text-uppercase" 
              v-i18n:it="'Romolo, la mascotte ufficiale dell’AS Roma, è uno degli abitanti della AS Roma Fan Zone'" 
              v-i18n:en="'ROMOLO, THE OFFICIAL MASCOT OF AS ROMA, IS ONE OF THE STAR RESIDENTS OF THE AS ROMA FAN ZONE'"></p>    
            <p class="mb-0 font-italic font-weight-bold text-white" 
              v-i18n:it="'Non perdere l’occasione per incontrarlo e vivere insieme a lui l’atmosfera del pre-partita. Fatti coinvolgere nelle attrazioni del Village dal lupacchiotto più famoso di tutti, pronto ad accogliere grandi e piccoli tifosi.'" 
              v-i18n:en="'Don\'t miss the opportunity to meet him and experience the pre-game atmosphere with him. Get involved in the attractions of the Village alongside the most famous wolf cub of all, ready and waiting to welcome fans of all ages.'"></p>    
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="text-white bg-primary" style="background-image:url(/img/fan-village/bg-text.svg);background-size:150px;background-attachment:fixed;">
      <b-container class="py-5 text-center my-auto">
        <b-row>
          <b-col md="12" class="mx-auto">
            <h1 class="font-weight-bold font-italic text-secondary mb-4 line-height-1 fanvillage__sec-title"
              v-i18n:it="'<span class=\'font-outline\'>Location</span><br /><span class=\'text-uppercase\'>e info</span>'"
              v-i18n:en="'<span class=\'font-outline\'>Location</span><br /><span class=\'text-uppercase\'>and info</span>'"></h1>
            <div class="mb-4">
              <b-img class="rounded d--none d--md-block" fluid src="/img/fan-village/map-fanvillage--25.webp" />
              <!--b-img class="rounded" src="/img/fan-village/map-fanvillage-sm.jpg" fluid></b-img-->
            </div>
            <!--p class="font-italic font-weight-bold"
            v-i18n:it="'Vieni a trovarci, in Piazza del Foro Italico, prima della partita!'" v-i18n:en="'Come and visit us in Piazza del Foro Italico before the game!'"></p>
            <div class="d-flex flex-column d-md-inline-flex">
              <b-link  v-b-toggle.signupModal class="btn btn-secondary btn-lg btn-block text-uppercase mb-3"
                v-if="!cookieLogin">
                <span
                  v-i18n:it="'Registrati ora'"
                  v-i18n:en="'Sign up now!'"></span>
              </b-link-->
              <!--b-link href="https://www.asroma.com/it/tickets/buy" target="_blank" class="btn btn-outline-secondary btn-block my-3">
                <span
                  v-i18n:it="'Acquista i biglietti per '"
                  v-i18n:en="'Buy tickets for'"></span>
                  {{nextEvent.match}}
              </b-link-->
            <!--/div-->
            <div
              v-if="!programmeExpired">
              <hr class="border-asr-silver mb-4"
                id="programme" />
              <h2 class="h1 font-weight-bold font-italic mb-4 text-uppercase text-secondary"
                v-i18n:it="'Prossimo appuntamento'"
                v-i18n:en="'Next appointment'"></h2>
              <div class="font-italic mb-4">
                <div class="h2 mb-0 font-weight-bold text-white">
                  <span v-if="$root.lang.id == 'it'">{{nextEvent.dateandtime | moment("D MMMM [dalle ore] H.mm")}}</span>
                  <span v-else>{{nextEvent.dateandtime | moment("D MMMM [from] h.mm A")}}</span>
                </div>
                <div class="h1 font-weight-bold text-secondary text-uppercase mb-4">
                  {{nextEvent.match}}
                </div>
                <div class="h6 font-weight-bold text-asr-grey mb-4 mt-n4"
                  v-if="nextEvent.competition">{{nextEvent.competition}}</div>
                <table class="m-0 table font-weight-bold programme-list w-auto mx-auto text-left programme-table"
                  v-b-visible="toggleProgVisibility">
                  <tr class="text-secondary"
                    v-for="prog in nextEvent.programme">
                    <td class="text-white text-nowrap">
                      <span v-if="$root.lang.id == 'it'">Ore {{getFullTime(prog.time) | moment("H:mm")}}</span>
                      <span v-else>{{getFullTime(prog.time) | moment("h.mm A")}}</span>
                    </td>
                    <td class="text-uppercase"
                      v-i18n.dictionary="prog.event"></td>
                  </tr>
                </table>
              </div>
              <div class="d-flex flex-column d-md-inline-flex">
                <b-link  v-b-toggle.signupModal class="btn btn-secondary btn-lg btn-block text-uppercase mb-3"
                  v-if="!cookieLogin">
                  <span
                    v-i18n:it="'Registrati ora'"
                    v-i18n:en="'Sign up now!'"></span>
                </b-link>
                <!--b-link href="https://www.asroma.com/it/tickets/buy" target="_blank" class="btn btn-outline-secondary btn-block my-3">
                  <span
                    v-i18n:it="'Acquista i biglietti per '"
                    v-i18n:en="'Buy tickets for'"></span>
                    {{nextEvent.match}}
                </b-link-->
              </div>
            </div>
            <div>
              <!--b-img class="rounded d--none d-md--block" fluid
                :src="`/img/fan-village/banner-fanvillage-250105-${$root.lang.id}.jpg`" /-->
            </div>
            <p class="font-italic font-weight-bold mt-4"
            v-i18n:it="'Vieni a trovarci, in Piazza del Foro Italico, prima della partita!'" v-i18n:en="'Come and visit us in Piazza del Foro Italico before the game!'"></p>
            <div class="d-flex flex-column d-md-inline-flex">
              <b-link  v-b-toggle.signupModal class="btn btn-secondary btn-lg btn-block text-uppercase mb-3"
                v-if="!cookieLogin">
                <span
                  v-i18n:it="'Registrati ora'"
                  v-i18n:en="'Sign up now!'"></span>
              </b-link>
              <!--b-link href="https://www.asroma.com/it/tickets/buy" target="_blank" class="btn btn-outline-secondary btn-block my-3">
                <span
                  v-i18n:it="'Acquista i biglietti per '"
                  v-i18n:en="'Buy tickets for'"></span>
                  {{nextEvent.match}}
              </b-link-->
            </div>    
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!--section class="bg-asr-black ext-white">
      <b-container class="py-5 text-center">
        <h1 class="font-weight-bold font-italic font-outline text-secondary mb-4 line-height-1 fanvillage__sec-title"
          v-i18n:it="'Photogallery'"
          v-i18n:en="'Photogallery'"></h1>
        <b-row>
          <b-col md="10" class="mx-auto">
            <b-carousel class="overflow-hidden mb--4" :interval="4000" controls indicators style="text-shadow: 1px 1px 2px #333;">
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-1.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-2.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-3.jpg"></b-carousel-slide>
              <!--b-carousel-slide img-src="/img/fan-village/gallery/gal24-4.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-5.jpg"></b-carousel-slide-->
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-6.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-7.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-8.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-9.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-10.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-11.jpg"></b-carousel-slide>
              <b-carousel-slide img-src="/img/fan-village/gallery/gal24-12.jpg"></b-carousel-slide>
            </b-carousel>
          </b-col>
        </b-row>
      </b-container>
    </section-->
    
    <b-sidebar id="signupModal" centered hide-footer header-class="bg-primary text-white myasr-modal" shadow backdrop right width="30em" body-class="bg-white"
      @shown="ssoLogin"
      @hidden="loginClean">
      <template #header="{hide}">
        <h5 class="modal-title d-flex align-items-center text-uppercase font-italic">
          <font-awesome-icon icon="chevron-left" role="button" class="mr-3"
            @click="loginModal = 'login'"
            v-if="loginModal != 'login'" />
          <b-img src="/img/digital/myasr/logo.png" height="20" class="mr-2" />
          <span class="d-none d-md-inline">
            <span v-show="loginModal == 'password'">Password Recovery</span>
            <span v-show="loginModal == 'login'"
              v-i18n:en="'Sign up now!'" v-i18n:it="'Registrati ora'"></span>
            <span v-show="loginModal == 'signup'">Create an account</span>
          </span>
        </h5>
        <div role="button" class="ml-auto"
          @click="hide">
          <font-awesome-icon icon="times" />
        </div>
      </template>
      <div class="p-3">
        <div id="registrationLoginDiv" ref="registrationLoginDiv" />
      </div>
    </b-sidebar>
  </div>

</template>

<script>
import SwiperClass, { Pagination, Navigation } from "swiper";
SwiperClass.use([Pagination, Navigation]);

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

import 'swiper/swiper-bundle.css'

export default {
  name: 'FanVillage',
  data() {
    return {
      loginModal: 'login',
      currentInhabitant: 'romolo',
      currentSustainability: 'community',
      programmeVisible: false,
      swiperOptions: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper1-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper1-button-next',
          prevEl: '.swiper1-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            slidesPerGroup: 2,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          },
          1024: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          }
        }
      },
      swiper2Options: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper2-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper2-button-next',
          prevEl: '.swiper2-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            slidesPerGroup: 2,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          },
          1024: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          }
        }
      },
      swiper3Options: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper3-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper3-button-next',
          prevEl: '.swiper3-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            slidesPerGroup: 2,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          },
          1024: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
            spaceBetween: 20,
            centeredSlides: false,
            centerInsufficientSlides: true
          }
        }
      },
      cookieLogin: null,
      nextEvent: {
        dateandtime: '2023-06-04T18:30:00',
        match: 'Roma-Spezia',
        competition: null,
        programme: [{
          time: '18:50',
          event: {
            en: '“Fast Foot Crew” Exhibition with Omag and Rey',
            it: 'Esibizione “Fast Foot Crew” con Omag e Rey'
          }
        }, {
          time: '19:05',
          event: {
            en: 'Stage Game Figli di Roma',
            it: 'Gioco Figli di Roma'
          }
        }, {
          time: '19:30',
          event: {
            en: 'Magicando with Raffaello Faccestamagia',
            it: 'Magicando con Raffaello Faccestamagia'
          }
        }, {
          time: '19:45',
          event: {
            en: 'BuzzER Quiz',
            it: 'BuzzER Quiz'
          }
        }, {
          time: '20:05',
          event: {
            en: 'Muoviti con KINTO',
            it: 'Muoviti con KINTO'
          }
        }, {
          time: '20:15',
          event: {
            en: 'New Balance Kick',
            it: 'New Balance Kick'
          }
        }, {
          time: '20:25',
          event: {
            en: '“Fast Foot Crew” Exhibition with Omag and Rey',
            it: 'Esibizione “Fast Foot Crew” con Omag e Rey'
          }
        }]
      },
      stand: [{
          img: '/img/fan-village/engage-25-1.webp',
          name: {
            en: 'Kick & Recharge',
            it: 'Kick & Recharge'
          },
          description: {
            en: 'Kick the ball as hard as you can and recharge your smartphone battery',
            it: 'Calcia il pallone più forte che puoi e ricarica la batteria del tuo smartphone'
          },
          comingsoon: true,
        },{
          img: '/img/fan-village/engage-25-6.webp',
          name: {
            en: 'Score',
            it: 'Score'
          },
          description: {
            en: 'Try to line up 3 balls before your opponent does',
            it: 'Prova a mettere in fila tre palloni prima che lo faccia il tuo avversario'
          },
          comingsoon: false,
        },{
          img: '/img/fan-village/engage-25-2.webp',
          name: {
            en: 'Subsoccer',
            it: 'Subsoccer'
          },
          description: {
            en: 'Would you like to play but need a break? Try Subsoccer and challenge your opponent to the best of three goals',
            it: 'Vorresti giocare ma hai bisogno di una pausa? Prova Subsoccer e sfida il tuo avversario al meglio dei tre goal'
          },
          comingsoon: false,
        },{
          img: '/img/fan-village/engage-25-3.webp',
          name: {
            en: 'Tic Tac Toe',
            it: 'Tic Tac Toe'
          },
          description: {
            en: 'Play tic-tac-toe by guessing players in AS Roma history from their careers and trophies won',
            it: 'Gioca a tris indovinando i giocatori della storia dell’AS Roma dalle loro carriere e dai trofei vinti'
          },
          comingsoon: true,
        },{
          img: '/img/fan-village/engage-25-4.webp',
          name: {
            en: 'Plinko',
            it: 'Plinko'
          },
          description: {
            en: 'Tries to drop the disk, with a player\'s jersey number, at his name',
            it: 'Cerca di far cadere il disco, con il numero di maglia di un giocatore, in corrispondenza del suo nome'
          },
          comingsoon: false,
        },{
          img: '/img/fan-village/engage-25-5.webp',
          name: {
            en: 'Magic Touch',
            it: 'Magic Touch'
          },
          description: {
            en: 'Test your technique and speed by attempting to replicate the tricks shown on the screen',
            it: 'Metti alla prova la tua tecnica e la tua velocità, tentando di replicare i trick mostrati sullo schermo'
          },
          comingsoon: true,
        },{
          img: '/img/fan-village/engage-25-9.webp',
          name: {
            en: 'Gladiators challenge',
            it: 'Gladiators challenge'
          },
          description: {
            en: 'Faces other fans in a challenge to the last goal, in the gladiator arena',
            it: 'Affronta gli altri tifosi in una sfida all’ultimo goal, nell’arena dei gladiatori'
          },
          comingsoon: true,
        },{
          img: '/img/fan-village/engage-25-8.webp',
          name: {
            en: 'Face Painting',
            it: 'Face Painting'
          },
          description: {
            en: 'Get ready to experience the match wearing the yellow and red colors',
            it: 'Preparati a vivere la partita con addosso i colori giallorossi'
          },
          comingsoon: false,
        },{
          img: '/img/fan-village/engage-24-9.webp',
          name: {
            en: 'Can You Stop?',
            it: 'Can You Stop?'
          },
          description: {
            en: 'Test your technique by trying to stop the tennis ball in the perimeter',
            it: 'Metti alla prova la tua tecnica, provando a stoppare la pallina da tennis nel perimetro'
          },
          comingsoon: true,
        },{
          img: '/img/fan-village/engage-25-7.webp',
          name: {
            en: 'Cornohole',
            it: 'Cornohole'
          },
          description: {
            en: 'Can you score? Challenge other fans in our game of skill',
            it: 'Riesci a fare centro? Sfida gli altri tifosi nel nostro gioco di abilità'
          },
          comingsoon: false,
        }],
      palco: [{
        img: '/img/fan-village/stage-25-1.webp',
        name: {
          en: 'Figli Di Roma',
          it: 'Figli Di Roma'
        },
        description: {
          en: 'Try to guess which iconic Roma character it is, using the clues at hand',
          it: 'Prova ad indovinare di che personaggio iconico della Roma si tratta, utilizzando gli indizi a disposizione'
        },
        comingsoon: false,
      },{
        img: '/img/fan-village/stage-25-2.webp',
        name: {
          en: 'ASR Kick',
          it: 'ASR Kick'
        },
        description: {
          en: 'Answer the “True or False” quiz by kicking in the correct goal',
          it: 'Rispondi al quiz "Vero o Falso", calciando nella porta corretta'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-24-3.webp',
        name: {
          en: 'Conosci le Tue Lupe',
          it: 'Conosci le Tue Lupe'
        },
        description: {
          en: 'Anecdotes, stories and highlights of our Giallorosse',
          it: 'Aneddoti, racconti e highlights delle nostre giallorosse'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-4.webp',
        name: {
          en: 'Questioniamo i Tifosi',
          it: 'Questioniamo i Tifosi'
        },
        description: {
          en: 'Hit the buzz button before everyone and answer correctly to win',
          it: 'Premi il pulsante del buzz prima di tutti e rispondi correttamente per vincere'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-5.webp',
        name: {
          en: 'Romapedia',
          it: 'Romapedia'
        },
        description: {
          en: 'Are you really a connoisseur of AS Roma? Test yourself in our dedicated quiz',
          it: 'Quanto conosci a fondo l\'AS Roma? Mettiti alla prova nel nostro quiz dedicato'
        },
        comingsoon: false,
      },{
        img: '/img/fan-village/stage-25-6.webp',
        name: {
          en: 'Guess who?',
          it: 'Indovina chi?'
        },
        description: {
          en: 'Sharpen your eyesight and try to guess the player hidden in the picture',
          it: 'Aguzza la vista e prova a indovinare il calciatore nascosto nella foto'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-24-7.webp',
        name: {
          en: 'Freestyler Show',
          it: 'Freestyler Show'
        },
        description: {
          en: 'Watch the freestyler crew who engages in a series of spectacular tricks and acrobatic dribbles',
          it: 'Ammira la nostra crew di freestyler mentre si cimenta in spettacolari trick e palleggi acrobatici'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-8.webp',
        name: {
          en: 'Magicando',
          it: 'Magicando'
        },
        description: {
          en: 'Magic tricks combined with moments of pure AS Roma-themed fun',
          it: 'Trick di magia uniti a momenti di puro divertimento a tema Roma'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-9.webp',
        name: {
          en: 'Romanismo a catena',
          it: 'Romanismo a catena'
        },
        description: {
          en: 'Test your team and try to get your partner to guess the secret word',
          it: 'Mettiti alla prova con la tua squadra e cerca di fare indovinare la parola segreta al tuo compagno'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-10.webp',
        name: {
          en: 'Anvedi che Carriera',
          it: 'Anvedi che Carriera'
        },
        description: {
          en: 'Through the logos of the teams in which he played, guess who the hidden player is',
          it: 'Attraverso i loghi delle squadre nelle quali ha giocato, indovina chi è il giocatore nascosto'
        },
        comingsoon: false,
      },{
        img: '/img/fan-village/stage-25-11.webp',
        name: {
          en: 'Emojiamo',
          it: 'Emojiamo'
        },
        description: {
          en: 'Guess the name of the player, using emoji clues',
          it: 'Indovina il nome del calciatore, utilizzando gli indizi emoji'
        },
        comingsoon: true,
      },{
        img: '/img/fan-village/stage-25-12.webp',
        name: {
          en: 'Trova l\'Intruso',
          it: 'Trova l\'Intruso'
        },
        description: {
          en: 'Analyze the line-up projected on the screen and find the intruder who was not present in that match',
          it: 'Analizza la formazione proietatta sullo schermo e trova l\'intruso che non era presente in quel match'
        },
        comingsoon: false,
      },{
        img: '/img/fan-village/stage-25-13.webp',
        name: {
          en: 'Romanistometro',
          it: 'Romanistometro'
        },
        description: {
          en: 'Challenge other fans by trying to replicate the commentaries of some of AS Roma\'s most iconic goals',
          it: 'Sfida gli altri tifosi, cercando di replicare i commenti di alcuni dei gol più iconici della Roma'
        },
        comingsoon: true,
      },]
    }
  },
  computed: {
    sustainabilityData() {
      return this.sustainability[this.currentSustainability];
    },
    programmeExpired() {
      return this.$moment().isAfter(this.nextEvent.dateandtime, 'day');
    }
  },
  methods: {
    ssoLogin() {
      gigya.accounts.showScreenSet({
        screenSet: 'lamagicaland-ASRoma-RegistrationLogin',
        startScreen: 'login-magicaland',
        containerID: "registrationLoginDiv",  
        regSource: 'http://toyotafanzone.asroma.com/',
        redirectURL: 'https://toyotafanzone.asroma.com//sso/afterLogin.php?lang=' + this.$root.lang.id
      });
    },
    loginClean() {
      this.$refs.registrationLoginDiv.innerHTML = '';
    },
    toggleProgVisibility(vis) {
      this.programmeVisible = vis;
    },
    filter(list) {
      return [...list.filter(i => !i.hidden).filter(i => !i.comingsoon), ...list.filter(i => !i.hidden).filter(i => i.comingsoon)];
    },
    imgTrans(name) {
      return name.replace('#LANG#', this.$root.lang.id);
    },
    getFullTime(time) {
      return this.nextEvent.dateandtime.split('T')[0] + 'T' + time;
    },
    setLanguage(lang) {
      window.location.href = `/?lang=${lang}`;
    }
  },
  mounted() {
    /*
    gigya.accounts.addEventHandlers({onLogin: function (response) {
      window.location.href = '/sso/afterLogin.php';
    }});
    */
    if (this.$cookies.isKey('SSO_logged'))
      this.cookieLogin = this.$cookies.get('SSO_name');
  },
  created() {
    var s = document.createElement('script');
    s.type='text/javascript';
    s.async=true;
    s.src = `https://cdns.eu1.gigya.com/js/gigya.js?apikey=4_xfRiNToLYVWQo59Rl--QpA&lang=${this.$root.lang.id}`;
    s.text = '{storageDomainOverride: "identity.asroma.com"}'
    document.getElementsByTagName('head')[0].appendChild(s);
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .swiper-pagination-bullet {background:#BBBCBC;opacity:1;}
  .swiper-pagination-bullet-active {background:#fab92b;}
  .jbtron-fan-village .container {min-height:130px;
    @media (min-width:768px) {min-height:300px;}
  }
  .fanvillage {background-image:url(/img/fan-village/bg-text.svg);background-size:150px;background-attachment:fixed;
    .fanvillage__intro {background:radial-gradient(closest-side, #980f2f 85%, transparent);}
    .fanvillage__logo {max-height:200px;}
    @media (max-width:1024px) {background-position:60%;}
    &__form-sep {
      &:before {position:absolute;content:'';left:0;right:0;top:50%;height:1px;background:#ced4da;}
    }
    .swiper-button-prev,.swiper-button-next{left:auto;right:auto;margin:0;width:auto;top:calc(50% - 40px);
      &:after {content:none;}
      @media (max-width:767px) {display:none;}
    }
    .swiper-button-prev {right:calc(100% - 5px);}
    .swiper-button-next {left:calc(100% - 5px);}
    @media (min-width:768px) {
      &__sec-title {font-size:72px;}
    }
  }
  #fv-inhabitants {overflow:hidden;
    @media (min-width:992px) {min-height:100vh;}
    .inhab-image {background:no-repeat center;background-size:cover;background-attachment:fixed;left:0;top:0;
      &--romolo {background-image:url(/img/fan-village/bg-romolo-6.webp);}
      &--band {background-image:url(/img/fan-village/bg-band-2.jpg);}
      @media (max-width:991px) {background-image:none;min-height:0;}
    }
    .inhab-mask {position:absolute;pointer-events:none;left:45%;top:0;bottom:0;width:100%;transform:skew(-10deg);opacity:.85;/*background:linear-gradient(to right,fade-out(#fab92b,1),fade-out(#fab92b,.2) 20%,fade-out(#fab92b,.2) 80%,fade-out(#fab92b,1));*/}
  }
  /*.programme-list {text-shadow:2px 2px #000;
    @media (min-width:768px) {font-size: 20px;}
  }*/
  .intro-lead {
    @media (max-width:767px) {font-size:1rem !important;}
  }
  .btn {
    @media (max-width:767px) {width: 100% !important;}
  }
  .btn-outline-secondary {backdrop-filter:blur(4px);}
  .programme-table {max-width:580px;}
  #app .product-img {aspect-ratio:320/180;object-fit:cover;border-bottom-left-radius:0 !important;border-bottom-right-radius:0 !important;}
  .coming-soon {background:rgba(20, 0, 0, .65);-webkit-backdrop-filter: blur(6px);backdrop-filter: blur(6px);left:0;top:0;}
</style>
